import { IAppState } from '../../reducers';

export const selectCreateSendMethod = (state: IAppState) => state.createSend.method;
